import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import classNames from "classnames";

export const Checkbox = ({
  checked = false,
  onChange = () => {},
  label = "",
  className = "",
  disabled = false,
  ...props
}) => {
  return (
    <div className={classNames("selection-wrapper", className)}>
      <Form.Check
        type="checkbox"
        label={label}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
